import React, { useMemo } from 'react';
import { DailyHistory } from '../types';

interface StatsPanelProps {
  history: { [date: string]: DailyHistory };
}

const StatsPanel: React.FC<StatsPanelProps> = ({ history }) => {
  const currentYear = new Date().getFullYear().toString();

  const yearStats = useMemo(() => {
    let unspentTokens = 0;
    let questsCompleted = 0;

    for (const date in history) {
      if (date.startsWith(currentYear)) {
        const dayHistory = history[date];
        unspentTokens += dayHistory.tokens || 0;
        questsCompleted += dayHistory.questsCompleted?.length || 0;
      }
    }
    return { unspentTokens, questsCompleted };
  }, [history, currentYear]);

  return (
    <div className="bg-slate-200/50 dark:bg-slate-800/50 rounded-xl p-4 border border-slate-300 dark:border-slate-700 flex-shrink-0">
      <h3 className="text-center font-bold text-slate-700 dark:text-slate-300 mb-3">{currentYear} Stats</h3>
      <div className="flex justify-around items-center">
        <div className="text-center">
          <p className="text-2xl font-bold" style={{color: 'var(--primary-500)'}}>{yearStats.unspentTokens}</p>
          <p className="text-xs text-slate-600 dark:text-slate-400">Total Unspent Tokens</p>
        </div>
        <div className="text-center">
          <p className="text-2xl font-bold" style={{color: 'var(--primary-500)'}}>{yearStats.questsCompleted}</p>
          <p className="text-xs text-slate-600 dark:text-slate-400">Total Quests Completed</p>
        </div>
      </div>
    </div>
  );
};

export default StatsPanel;